function cov_syhivb711() {
  var path = "/__w/code/code/js/packages/cinderblocks/src/core/AddressInput/AddressInput.tsx";
  var hash = "7ff86cad7c9dbc4cc68f0bb17502a1f31529baff";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/cinderblocks/src/core/AddressInput/AddressInput.tsx",
    statementMap: {
      "0": {
        start: {
          line: 19,
          column: 32
        },
        end: {
          line: 19,
          column: 35
        }
      },
      "1": {
        start: {
          line: 79,
          column: 50
        },
        end: {
          line: 298,
          column: 1
        }
      },
      "2": {
        start: {
          line: 105,
          column: 40
        },
        end: {
          line: 105,
          column: 78
        }
      },
      "3": {
        start: {
          line: 106,
          column: 46
        },
        end: {
          line: 106,
          column: 91
        }
      },
      "4": {
        start: {
          line: 107,
          column: 38
        },
        end: {
          line: 107,
          column: 66
        }
      },
      "5": {
        start: {
          line: 108,
          column: 36
        },
        end: {
          line: 108,
          column: 51
        }
      },
      "6": {
        start: {
          line: 109,
          column: 25
        },
        end: {
          line: 109,
          column: 73
        }
      },
      "7": {
        start: {
          line: 109,
          column: 40
        },
        end: {
          line: 109,
          column: 72
        }
      },
      "8": {
        start: {
          line: 110,
          column: 19
        },
        end: {
          line: 110,
          column: 49
        }
      },
      "9": {
        start: {
          line: 112,
          column: 2
        },
        end: {
          line: 114,
          column: 41
        }
      },
      "10": {
        start: {
          line: 113,
          column: 4
        },
        end: {
          line: 113,
          column: 39
        }
      },
      "11": {
        start: {
          line: 116,
          column: 2
        },
        end: {
          line: 118,
          column: 39
        }
      },
      "12": {
        start: {
          line: 117,
          column: 4
        },
        end: {
          line: 117,
          column: 37
        }
      },
      "13": {
        start: {
          line: 120,
          column: 27
        },
        end: {
          line: 123,
          column: 3
        }
      },
      "14": {
        start: {
          line: 121,
          column: 4
        },
        end: {
          line: 121,
          column: 28
        }
      },
      "15": {
        start: {
          line: 122,
          column: 4
        },
        end: {
          line: 122,
          column: 23
        }
      },
      "16": {
        start: {
          line: 125,
          column: 35
        },
        end: {
          line: 167,
          column: 3
        }
      },
      "17": {
        start: {
          line: 127,
          column: 6
        },
        end: {
          line: 165,
          column: 33
        }
      },
      "18": {
        start: {
          line: 128,
          column: 8
        },
        end: {
          line: 131,
          column: 9
        }
      },
      "19": {
        start: {
          line: 129,
          column: 10
        },
        end: {
          line: 129,
          column: 29
        }
      },
      "20": {
        start: {
          line: 130,
          column: 10
        },
        end: {
          line: 130,
          column: 17
        }
      },
      "21": {
        start: {
          line: 133,
          column: 8
        },
        end: {
          line: 164,
          column: 9
        }
      },
      "22": {
        start: {
          line: 134,
          column: 27
        },
        end: {
          line: 134,
          column: 81
        }
      },
      "23": {
        start: {
          line: 135,
          column: 23
        },
        end: {
          line: 135,
          column: 44
        }
      },
      "24": {
        start: {
          line: 138,
          column: 10
        },
        end: {
          line: 142,
          column: 13
        }
      },
      "25": {
        start: {
          line: 139,
          column: 12
        },
        end: {
          line: 139,
          column: 73
        }
      },
      "26": {
        start: {
          line: 140,
          column: 12
        },
        end: {
          line: 140,
          column: 85
        }
      },
      "27": {
        start: {
          line: 141,
          column: 12
        },
        end: {
          line: 141,
          column: 50
        }
      },
      "28": {
        start: {
          line: 145,
          column: 27
        },
        end: {
          line: 158,
          column: 12
        }
      },
      "29": {
        start: {
          line: 146,
          column: 12
        },
        end: {
          line: 146,
          column: 40
        }
      },
      "30": {
        start: {
          line: 147,
          column: 12
        },
        end: {
          line: 156,
          column: 13
        }
      },
      "31": {
        start: {
          line: 148,
          column: 28
        },
        end: {
          line: 148,
          column: 46
        }
      },
      "32": {
        start: {
          line: 149,
          column: 35
        },
        end: {
          line: 151,
          column: 15
        }
      },
      "33": {
        start: {
          line: 150,
          column: 16
        },
        end: {
          line: 150,
          column: 44
        }
      },
      "34": {
        start: {
          line: 152,
          column: 14
        },
        end: {
          line: 155,
          column: 16
        }
      },
      "35": {
        start: {
          line: 157,
          column: 12
        },
        end: {
          line: 157,
          column: 24
        }
      },
      "36": {
        start: {
          line: 160,
          column: 10
        },
        end: {
          line: 160,
          column: 35
        }
      },
      "37": {
        start: {
          line: 162,
          column: 10
        },
        end: {
          line: 162,
          column: 29
        }
      },
      "38": {
        start: {
          line: 163,
          column: 10
        },
        end: {
          line: 163,
          column: 36
        }
      },
      "39": {
        start: {
          line: 169,
          column: 28
        },
        end: {
          line: 176,
          column: 3
        }
      },
      "40": {
        start: {
          line: 170,
          column: 18
        },
        end: {
          line: 170,
          column: 32
        }
      },
      "41": {
        start: {
          line: 171,
          column: 4
        },
        end: {
          line: 171,
          column: 25
        }
      },
      "42": {
        start: {
          line: 172,
          column: 4
        },
        end: {
          line: 172,
          column: 36
        }
      },
      "43": {
        start: {
          line: 173,
          column: 4
        },
        end: {
          line: 175,
          column: 5
        }
      },
      "44": {
        start: {
          line: 174,
          column: 6
        },
        end: {
          line: 174,
          column: 25
        }
      },
      "45": {
        start: {
          line: 178,
          column: 33
        },
        end: {
          line: 220,
          column: 3
        }
      },
      "46": {
        start: {
          line: 180,
          column: 4
        },
        end: {
          line: 180,
          column: 29
        }
      },
      "47": {
        start: {
          line: 182,
          column: 4
        },
        end: {
          line: 182,
          column: 34
        }
      },
      "48": {
        start: {
          line: 183,
          column: 4
        },
        end: {
          line: 183,
          column: 42
        }
      },
      "49": {
        start: {
          line: 184,
          column: 4
        },
        end: {
          line: 184,
          column: 23
        }
      },
      "50": {
        start: {
          line: 185,
          column: 4
        },
        end: {
          line: 185,
          column: 23
        }
      },
      "51": {
        start: {
          line: 188,
          column: 6
        },
        end: {
          line: 198,
          column: 12
        }
      },
      "52": {
        start: {
          line: 200,
          column: 4
        },
        end: {
          line: 219,
          column: 5
        }
      },
      "53": {
        start: {
          line: 201,
          column: 23
        },
        end: {
          line: 201,
          column: 39
        }
      },
      "54": {
        start: {
          line: 202,
          column: 39
        },
        end: {
          line: 202,
          column: 60
        }
      },
      "55": {
        start: {
          line: 205,
          column: 6
        },
        end: {
          line: 212,
          column: 7
        }
      },
      "56": {
        start: {
          line: 206,
          column: 8
        },
        end: {
          line: 211,
          column: 9
        }
      },
      "57": {
        start: {
          line: 207,
          column: 35
        },
        end: {
          line: 207,
          column: 71
        }
      },
      "58": {
        start: {
          line: 208,
          column: 10
        },
        end: {
          line: 208,
          column: 47
        }
      },
      "59": {
        start: {
          line: 210,
          column: 10
        },
        end: {
          line: 210,
          column: 46
        }
      },
      "60": {
        start: {
          line: 214,
          column: 6
        },
        end: {
          line: 214,
          column: 31
        }
      },
      "61": {
        start: {
          line: 216,
          column: 6
        },
        end: {
          line: 216,
          column: 32
        }
      },
      "62": {
        start: {
          line: 218,
          column: 6
        },
        end: {
          line: 218,
          column: 26
        }
      },
      "63": {
        start: {
          line: 222,
          column: 21
        },
        end: {
          line: 246,
          column: 3
        }
      },
      "64": {
        start: {
          line: 224,
          column: 26
        },
        end: {
          line: 229,
          column: 14
        }
      },
      "65": {
        start: {
          line: 230,
          column: 23
        },
        end: {
          line: 230,
          column: 65
        }
      },
      "66": {
        start: {
          line: 232,
          column: 4
        },
        end: {
          line: 245,
          column: 6
        }
      },
      "67": {
        start: {
          line: 249,
          column: 4
        },
        end: {
          line: 256,
          column: 6
        }
      },
      "68": {
        start: {
          line: 258,
          column: 35
        },
        end: {
          line: 258,
          column: 46
        }
      },
      "69": {
        start: {
          line: 259,
          column: 2
        },
        end: {
          line: 269,
          column: 3
        }
      },
      "70": {
        start: {
          line: 260,
          column: 20
        },
        end: {
          line: 266,
          column: 5
        }
      },
      "71": {
        start: {
          line: 261,
          column: 6
        },
        end: {
          line: 265,
          column: 7
        }
      },
      "72": {
        start: {
          line: 262,
          column: 8
        },
        end: {
          line: 262,
          column: 47
        }
      },
      "73": {
        start: {
          line: 263,
          column: 13
        },
        end: {
          line: 265,
          column: 7
        }
      },
      "74": {
        start: {
          line: 264,
          column: 8
        },
        end: {
          line: 264,
          column: 47
        }
      },
      "75": {
        start: {
          line: 267,
          column: 27
        },
        end: {
          line: 267,
          column: 59
        }
      },
      "76": {
        start: {
          line: 268,
          column: 4
        },
        end: {
          line: 268,
          column: 31
        }
      },
      "77": {
        start: {
          line: 271,
          column: 2
        },
        end: {
          line: 297,
          column: 4
        }
      },
      "78": {
        start: {
          line: 286,
          column: 22
        },
        end: {
          line: 286,
          column: 40
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 79,
            column: 50
          },
          end: {
            line: 79,
            column: 51
          }
        },
        loc: {
          start: {
            line: 104,
            column: 6
          },
          end: {
            line: 298,
            column: 1
          }
        },
        line: 104
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 109,
            column: 34
          },
          end: {
            line: 109,
            column: 35
          }
        },
        loc: {
          start: {
            line: 109,
            column: 40
          },
          end: {
            line: 109,
            column: 72
          }
        },
        line: 109
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 112,
            column: 12
          },
          end: {
            line: 112,
            column: 13
          }
        },
        loc: {
          start: {
            line: 112,
            column: 18
          },
          end: {
            line: 114,
            column: 3
          }
        },
        line: 112
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 116,
            column: 12
          },
          end: {
            line: 116,
            column: 13
          }
        },
        loc: {
          start: {
            line: 116,
            column: 18
          },
          end: {
            line: 118,
            column: 3
          }
        },
        line: 116
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 120,
            column: 27
          },
          end: {
            line: 120,
            column: 28
          }
        },
        loc: {
          start: {
            line: 120,
            column: 33
          },
          end: {
            line: 123,
            column: 3
          }
        },
        line: 120
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 126,
            column: 4
          },
          end: {
            line: 126,
            column: 5
          }
        },
        loc: {
          start: {
            line: 127,
            column: 6
          },
          end: {
            line: 165,
            column: 33
          }
        },
        line: 127
      },
      "6": {
        name: "(anonymous_6)",
        decl: {
          start: {
            line: 127,
            column: 15
          },
          end: {
            line: 127,
            column: 16
          }
        },
        loc: {
          start: {
            line: 127,
            column: 40
          },
          end: {
            line: 165,
            column: 7
          }
        },
        line: 127
      },
      "7": {
        name: "(anonymous_7)",
        decl: {
          start: {
            line: 138,
            column: 35
          },
          end: {
            line: 138,
            column: 36
          }
        },
        loc: {
          start: {
            line: 138,
            column: 71
          },
          end: {
            line: 142,
            column: 11
          }
        },
        line: 138
      },
      "8": {
        name: "(anonymous_8)",
        decl: {
          start: {
            line: 145,
            column: 51
          },
          end: {
            line: 145,
            column: 52
          }
        },
        loc: {
          start: {
            line: 145,
            column: 87
          },
          end: {
            line: 158,
            column: 11
          }
        },
        line: 145
      },
      "9": {
        name: "(anonymous_9)",
        decl: {
          start: {
            line: 149,
            column: 63
          },
          end: {
            line: 149,
            column: 64
          }
        },
        loc: {
          start: {
            line: 150,
            column: 16
          },
          end: {
            line: 150,
            column: 44
          }
        },
        line: 150
      },
      "10": {
        name: "(anonymous_10)",
        decl: {
          start: {
            line: 169,
            column: 28
          },
          end: {
            line: 169,
            column: 29
          }
        },
        loc: {
          start: {
            line: 169,
            column: 72
          },
          end: {
            line: 176,
            column: 3
          }
        },
        line: 169
      },
      "11": {
        name: "(anonymous_11)",
        decl: {
          start: {
            line: 178,
            column: 33
          },
          end: {
            line: 178,
            column: 34
          }
        },
        loc: {
          start: {
            line: 178,
            column: 79
          },
          end: {
            line: 220,
            column: 3
          }
        },
        line: 178
      },
      "12": {
        name: "(anonymous_12)",
        decl: {
          start: {
            line: 222,
            column: 21
          },
          end: {
            line: 222,
            column: 22
          }
        },
        loc: {
          start: {
            line: 222,
            column: 61
          },
          end: {
            line: 246,
            column: 3
          }
        },
        line: 222
      },
      "13": {
        name: "(anonymous_13)",
        decl: {
          start: {
            line: 260,
            column: 20
          },
          end: {
            line: 260,
            column: 21
          }
        },
        loc: {
          start: {
            line: 260,
            column: 26
          },
          end: {
            line: 266,
            column: 5
          }
        },
        line: 260
      },
      "14": {
        name: "(anonymous_14)",
        decl: {
          start: {
            line: 286,
            column: 16
          },
          end: {
            line: 286,
            column: 17
          }
        },
        loc: {
          start: {
            line: 286,
            column: 22
          },
          end: {
            line: 286,
            column: 40
          }
        },
        line: 286
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 88,
            column: 2
          },
          end: {
            line: 88,
            column: 25
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 88,
            column: 20
          },
          end: {
            line: 88,
            column: 25
          }
        }],
        line: 88
      },
      "1": {
        loc: {
          start: {
            line: 107,
            column: 47
          },
          end: {
            line: 107,
            column: 65
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 107,
            column: 47
          },
          end: {
            line: 107,
            column: 59
          }
        }, {
          start: {
            line: 107,
            column: 63
          },
          end: {
            line: 107,
            column: 65
          }
        }],
        line: 107
      },
      "2": {
        loc: {
          start: {
            line: 128,
            column: 8
          },
          end: {
            line: 131,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 128,
            column: 8
          },
          end: {
            line: 131,
            column: 9
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 128
      },
      "3": {
        loc: {
          start: {
            line: 140,
            column: 24
          },
          end: {
            line: 140,
            column: 84
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 140,
            column: 24
          },
          end: {
            line: 140,
            column: 39
          }
        }, {
          start: {
            line: 140,
            column: 43
          },
          end: {
            line: 140,
            column: 62
          }
        }, {
          start: {
            line: 140,
            column: 66
          },
          end: {
            line: 140,
            column: 84
          }
        }],
        line: 140
      },
      "4": {
        loc: {
          start: {
            line: 147,
            column: 12
          },
          end: {
            line: 156,
            column: 13
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 147,
            column: 12
          },
          end: {
            line: 156,
            column: 13
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 147
      },
      "5": {
        loc: {
          start: {
            line: 148,
            column: 28
          },
          end: {
            line: 148,
            column: 46
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 148,
            column: 28
          },
          end: {
            line: 148,
            column: 40
          }
        }, {
          start: {
            line: 148,
            column: 44
          },
          end: {
            line: 148,
            column: 46
          }
        }],
        line: 148
      },
      "6": {
        loc: {
          start: {
            line: 149,
            column: 36
          },
          end: {
            line: 149,
            column: 54
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 149,
            column: 36
          },
          end: {
            line: 149,
            column: 48
          }
        }, {
          start: {
            line: 149,
            column: 52
          },
          end: {
            line: 149,
            column: 54
          }
        }],
        line: 149
      },
      "7": {
        loc: {
          start: {
            line: 153,
            column: 16
          },
          end: {
            line: 154,
            column: 87
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 153,
            column: 17
          },
          end: {
            line: 153,
            column: 34
          }
        }, {
          start: {
            line: 153,
            column: 38
          },
          end: {
            line: 153,
            column: 61
          }
        }, {
          start: {
            line: 154,
            column: 17
          },
          end: {
            line: 154,
            column: 35
          }
        }, {
          start: {
            line: 154,
            column: 39
          },
          end: {
            line: 154,
            column: 86
          }
        }],
        line: 153
      },
      "8": {
        loc: {
          start: {
            line: 173,
            column: 4
          },
          end: {
            line: 175,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 173,
            column: 4
          },
          end: {
            line: 175,
            column: 5
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 173
      },
      "9": {
        loc: {
          start: {
            line: 188,
            column: 6
          },
          end: {
            line: 198,
            column: 12
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 189,
            column: 10
          },
          end: {
            line: 193,
            column: 12
          }
        }, {
          start: {
            line: 194,
            column: 10
          },
          end: {
            line: 198,
            column: 12
          }
        }],
        line: 188
      },
      "10": {
        loc: {
          start: {
            line: 205,
            column: 6
          },
          end: {
            line: 212,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 205,
            column: 6
          },
          end: {
            line: 212,
            column: 7
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 205
      },
      "11": {
        loc: {
          start: {
            line: 205,
            column: 10
          },
          end: {
            line: 205,
            column: 47
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 205,
            column: 10
          },
          end: {
            line: 205,
            column: 25
          }
        }, {
          start: {
            line: 205,
            column: 29
          },
          end: {
            line: 205,
            column: 47
          }
        }],
        line: 205
      },
      "12": {
        loc: {
          start: {
            line: 230,
            column: 23
          },
          end: {
            line: 230,
            column: 65
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 230,
            column: 30
          },
          end: {
            line: 230,
            column: 49
          }
        }, {
          start: {
            line: 230,
            column: 52
          },
          end: {
            line: 230,
            column: 65
          }
        }],
        line: 230
      },
      "13": {
        loc: {
          start: {
            line: 249,
            column: 4
          },
          end: {
            line: 256,
            column: 6
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 249,
            column: 4
          },
          end: {
            line: 249,
            column: 8
          }
        }, {
          start: {
            line: 250,
            column: 5
          },
          end: {
            line: 256,
            column: 5
          }
        }],
        line: 249
      },
      "14": {
        loc: {
          start: {
            line: 250,
            column: 5
          },
          end: {
            line: 256,
            column: 5
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 251,
            column: 6
          },
          end: {
            line: 253,
            column: 12
          }
        }, {
          start: {
            line: 255,
            column: 6
          },
          end: {
            line: 255,
            column: 22
          }
        }],
        line: 250
      },
      "15": {
        loc: {
          start: {
            line: 259,
            column: 2
          },
          end: {
            line: 269,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 259,
            column: 2
          },
          end: {
            line: 269,
            column: 3
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 259
      },
      "16": {
        loc: {
          start: {
            line: 261,
            column: 6
          },
          end: {
            line: 265,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 261,
            column: 6
          },
          end: {
            line: 265,
            column: 7
          }
        }, {
          start: {
            line: 263,
            column: 13
          },
          end: {
            line: 265,
            column: 7
          }
        }],
        line: 261
      },
      "17": {
        loc: {
          start: {
            line: 261,
            column: 10
          },
          end: {
            line: 261,
            column: 46
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 261,
            column: 10
          },
          end: {
            line: 261,
            column: 28
          }
        }, {
          start: {
            line: 261,
            column: 32
          },
          end: {
            line: 261,
            column: 46
          }
        }],
        line: 261
      },
      "18": {
        loc: {
          start: {
            line: 263,
            column: 13
          },
          end: {
            line: 265,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 263,
            column: 13
          },
          end: {
            line: 265,
            column: 7
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 263
      },
      "19": {
        loc: {
          start: {
            line: 263,
            column: 17
          },
          end: {
            line: 263,
            column: 76
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 263,
            column: 17
          },
          end: {
            line: 263,
            column: 31
          }
        }, {
          start: {
            line: 263,
            column: 35
          },
          end: {
            line: 263,
            column: 76
          }
        }],
        line: 263
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0,
      "29": 0,
      "30": 0,
      "31": 0,
      "32": 0,
      "33": 0,
      "34": 0,
      "35": 0,
      "36": 0,
      "37": 0,
      "38": 0,
      "39": 0,
      "40": 0,
      "41": 0,
      "42": 0,
      "43": 0,
      "44": 0,
      "45": 0,
      "46": 0,
      "47": 0,
      "48": 0,
      "49": 0,
      "50": 0,
      "51": 0,
      "52": 0,
      "53": 0,
      "54": 0,
      "55": 0,
      "56": 0,
      "57": 0,
      "58": 0,
      "59": 0,
      "60": 0,
      "61": 0,
      "62": 0,
      "63": 0,
      "64": 0,
      "65": 0,
      "66": 0,
      "67": 0,
      "68": 0,
      "69": 0,
      "70": 0,
      "71": 0,
      "72": 0,
      "73": 0,
      "74": 0,
      "75": 0,
      "76": 0,
      "77": 0,
      "78": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0
    },
    b: {
      "0": [0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0, 0],
      "4": [0, 0],
      "5": [0, 0],
      "6": [0, 0],
      "7": [0, 0, 0, 0],
      "8": [0, 0],
      "9": [0, 0],
      "10": [0, 0],
      "11": [0, 0],
      "12": [0, 0],
      "13": [0, 0],
      "14": [0, 0],
      "15": [0, 0],
      "16": [0, 0],
      "17": [0, 0],
      "18": [0, 0],
      "19": [0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "7ff86cad7c9dbc4cc68f0bb17502a1f31529baff"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_syhivb711 = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_syhivb711();
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.get-prototype-of.js";
import "core-js/modules/es.object.set-prototype-of.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.test.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.string.match.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.filter.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/esnext.iterator.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useEffect, useMemo, useRef, useState } from 'react';
import { ButtonLoadingAnimation, Icons, Text } from '@opendoor/bricks-next';
import { Box } from '@opendoor/bricks/core';
import debounce from "lodash/debounce.js";
import { validateAddress as validateAddressHelper } from "../../helpers/addressValidation.mjs";
import { ALLOWED_TYPES, buildAutocompleteUrl, buildPlacesUrl, generateGoogleMapsSessionToken } from "../../helpers/googleMaps.mjs";
import AutocompleteInput from "../AutocompleteInput/index.mjs";
var DEBOUNCE_INVOKE_WAIT_MS = (cov_syhivb711().s[0]++, 100);
/**
 * @param actionButton overrides `icon` in the suffix position when provided
 */
cov_syhivb711().s[1]++;
var AddressInput = function AddressInput(_ref) {
  var _ref8, _ref15;
  var id = _ref.id,
    placeholder = _ref.placeholder,
    disabled = _ref.disabled,
    hideLabel = _ref.hideLabel,
    label = _ref.label,
    defaultValue = _ref.defaultValue,
    onAddressSelect = _ref.onAddressSelect,
    onAddressValidated = _ref.onAddressValidated,
    _ref$validateAddress = _ref.validateAddress,
    validateAddress = _ref$validateAddress === void 0 ? (cov_syhivb711().b[0][0]++, false) : _ref$validateAddress,
    onError = _ref.onError,
    onPredictionsChange = _ref.onPredictionsChange,
    onSearchTermChange = _ref.onSearchTermChange,
    onFocus = _ref.onFocus,
    onBlur = _ref.onBlur,
    customAction = _ref.customAction,
    listBoxId = _ref.listBoxId,
    listBoxAriaLabel = _ref.listBoxAriaLabel,
    icon = _ref.icon,
    actionButton = _ref.actionButton,
    size = _ref.size,
    supportText = _ref.supportText,
    errorText = _ref.errorText,
    invalid = _ref.invalid,
    required = _ref.required;
  cov_syhivb711().f[0]++;
  var _ref2 = (cov_syhivb711().s[2]++, useState([])),
    _ref3 = _slicedToArray(_ref2, 2),
    predictions = _ref3[0],
    setPredictions = _ref3[1];
  var _ref4 = (cov_syhivb711().s[3]++, useState(null)),
    _ref5 = _slicedToArray(_ref4, 2),
    usedPrediction = _ref5[0],
    setUsedPrediction = _ref5[1];
  var _ref6 = (cov_syhivb711().s[4]++, useState((_ref8 = (cov_syhivb711().b[1][0]++, defaultValue)) !== null && _ref8 !== void 0 ? _ref8 : (cov_syhivb711().b[1][1]++, ''))),
    _ref7 = _slicedToArray(_ref6, 2),
    searchTerm = _ref7[0],
    setSearchTerm = _ref7[1];
  var _ref9 = (cov_syhivb711().s[5]++, useState(false)),
    _ref0 = _slicedToArray(_ref9, 2),
    isLoading = _ref0[0],
    setIsLoading = _ref0[1];
  var _ref1 = (cov_syhivb711().s[6]++, useState(function () {
      cov_syhivb711().f[1]++;
      cov_syhivb711().s[7]++;
      return generateGoogleMapsSessionToken();
    })),
    _ref10 = _slicedToArray(_ref1, 1),
    sessionToken = _ref10[0];
  var inputRef = (cov_syhivb711().s[8]++, useRef(null));
  cov_syhivb711().s[9]++;
  useEffect(function () {
    cov_syhivb711().f[2]++;
    cov_syhivb711().s[10]++;
    onPredictionsChange === null || onPredictionsChange === void 0 || onPredictionsChange(predictions);
  }, [predictions, onPredictionsChange]);
  cov_syhivb711().s[11]++;
  useEffect(function () {
    cov_syhivb711().f[3]++;
    cov_syhivb711().s[12]++;
    onSearchTermChange === null || onSearchTermChange === void 0 || onSearchTermChange(searchTerm);
  }, [searchTerm, onSearchTermChange]);
  cov_syhivb711().s[13]++;
  var clearPredictions = function clearPredictions() {
    cov_syhivb711().f[4]++;
    cov_syhivb711().s[14]++;
    setUsedPrediction(null);
    cov_syhivb711().s[15]++;
    setPredictions([]);
  };
  var fetchAutocompleteOptions = (cov_syhivb711().s[16]++, useMemo(function () {
    cov_syhivb711().f[5]++;
    cov_syhivb711().s[17]++;
    return debounce(/*#__PURE__*/function () {
      var _ref11 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(input) {
        var response, data, filtered, _t;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              cov_syhivb711().f[6]++;
              cov_syhivb711().s[18]++;
              if (input) {
                _context.n = 1;
                break;
              }
              cov_syhivb711().b[2][0]++;
              cov_syhivb711().s[19]++;
              clearPredictions();
              cov_syhivb711().s[20]++;
              return _context.a(2);
            case 1:
              cov_syhivb711().b[2][1]++;
            case 2:
              cov_syhivb711().s[21]++;
              _context.p = 3;
              cov_syhivb711().s[22]++;
              _context.n = 4;
              return fetch(buildAutocompleteUrl(input, sessionToken));
            case 4:
              response = _context.v;
              cov_syhivb711().s[23]++;
              _context.n = 5;
              return response.json();
            case 5:
              data = _context.v;
              cov_syhivb711().s[24]++;
              // Clean descriptions by removing ', USA' and add required AutocompleteItem properties
              data.predictions.forEach(function (result) {
                cov_syhivb711().f[7]++;
                cov_syhivb711().s[25]++;
                result.description = result.description.replace(', USA', '');
                cov_syhivb711().s[26]++;
                result.id = (cov_syhivb711().b[3][0]++, result.place_id) || (cov_syhivb711().b[3][1]++, result.addressToken) || (cov_syhivb711().b[3][2]++, result.description);
                cov_syhivb711().s[27]++;
                result.ariaLabel = result.description;
              });

              // Filter predictions based on type and term count
              filtered = (cov_syhivb711().s[28]++, data.predictions.filter(function (result) {
                cov_syhivb711().f[8]++;
                cov_syhivb711().s[29]++;
                result.source = data.source;
                cov_syhivb711().s[30]++;
                if (data.source === 'google') {
                  var _ref12, _ref13;
                  cov_syhivb711().b[4][0]++;
                  var terms = (cov_syhivb711().s[31]++, (_ref12 = (cov_syhivb711().b[5][0]++, result.terms)) !== null && _ref12 !== void 0 ? _ref12 : (cov_syhivb711().b[5][1]++, []));
                  var allowedTypes = (cov_syhivb711().s[32]++, ((_ref13 = (cov_syhivb711().b[6][0]++, result.types)) !== null && _ref13 !== void 0 ? _ref13 : (cov_syhivb711().b[6][1]++, [])).filter(function (type) {
                    cov_syhivb711().f[9]++;
                    cov_syhivb711().s[33]++;
                    return ALLOWED_TYPES.includes(type);
                  }));
                  cov_syhivb711().s[34]++;
                  return (cov_syhivb711().b[7][0]++, terms.length >= 5) && (cov_syhivb711().b[7][1]++, allowedTypes.length > 0) || (cov_syhivb711().b[7][2]++, terms.length === 4) && (cov_syhivb711().b[7][3]++, terms[0].value.match(/^\d+\S*\s\S+\s/) !== null);
                } else {
                  cov_syhivb711().b[4][1]++;
                }
                cov_syhivb711().s[35]++;
                return true;
              }));
              cov_syhivb711().s[36]++;
              setPredictions(filtered);
              _context.n = 7;
              break;
            case 6:
              _context.p = 6;
              _t = _context.v;
              cov_syhivb711().s[37]++;
              clearPredictions();
              cov_syhivb711().s[38]++;
              onError === null || onError === void 0 || onError(_t);
            case 7:
              return _context.a(2);
          }
        }, _callee, null, [[3, 6]]);
      }));
      return function (_x) {
        return _ref11.apply(this, arguments);
      };
    }(), DEBOUNCE_INVOKE_WAIT_MS);
  }, [sessionToken, onError]));
  cov_syhivb711().s[39]++;
  var handleInputChange = function handleInputChange(e) {
    cov_syhivb711().f[10]++;
    var value = (cov_syhivb711().s[40]++, e.target.value);
    cov_syhivb711().s[41]++;
    setSearchTerm(value);
    cov_syhivb711().s[42]++;
    fetchAutocompleteOptions(value);
    cov_syhivb711().s[43]++;
    if (value === '') {
      cov_syhivb711().b[8][0]++;
      cov_syhivb711().s[44]++;
      clearPredictions();
    } else {
      cov_syhivb711().b[8][1]++;
    }
  };
  cov_syhivb711().s[45]++;
  var handlePredictionSelect = /*#__PURE__*/function () {
    var _ref14 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(prediction) {
      var _inputRef$current;
      var url, response, address, validationResult, _t2, _t3;
      return _regenerator().w(function (_context2) {
        while (1) switch (_context2.p = _context2.n) {
          case 0:
            cov_syhivb711().f[11]++;
            cov_syhivb711().s[46]++;
            // Blur input to dismiss keyboard before async operations that may open modals
            (_inputRef$current = inputRef.current) === null || _inputRef$current === void 0 || _inputRef$current.blur();
            cov_syhivb711().s[47]++;
            setUsedPrediction(prediction);
            cov_syhivb711().s[48]++;
            setSearchTerm(prediction.description);
            cov_syhivb711().s[49]++;
            setPredictions([]);
            cov_syhivb711().s[50]++;
            setIsLoading(true);
            url = (cov_syhivb711().s[51]++, prediction.source === 'google' ? (cov_syhivb711().b[9][0]++, buildPlacesUrl({
              source: 'google',
              placeId: prediction.place_id,
              sessionToken: sessionToken
            })) : (cov_syhivb711().b[9][1]++, buildPlacesUrl({
              source: 'casa',
              addressToken: prediction.addressToken,
              sessionToken: sessionToken
            })));
            cov_syhivb711().s[52]++;
            _context2.p = 1;
            cov_syhivb711().s[53]++;
            _context2.n = 2;
            return fetch(url);
          case 2:
            response = _context2.v;
            cov_syhivb711().s[54]++;
            _context2.n = 3;
            return response.json();
          case 3:
            address = _context2.v;
            cov_syhivb711().s[55]++;
            if (!((cov_syhivb711().b[11][0]++, validateAddress) && (cov_syhivb711().b[11][1]++, onAddressValidated))) {
              _context2.n = 8;
              break;
            }
            cov_syhivb711().b[10][0]++;
            cov_syhivb711().s[56]++;
            _context2.p = 4;
            cov_syhivb711().s[57]++;
            _context2.n = 5;
            return validateAddressHelper(address);
          case 5:
            validationResult = _context2.v;
            cov_syhivb711().s[58]++;
            onAddressValidated(validationResult);
            _context2.n = 7;
            break;
          case 6:
            _context2.p = 6;
            _t2 = _context2.v;
            cov_syhivb711().s[59]++;
            onError === null || onError === void 0 || onError(_t2);
          case 7:
            _context2.n = 9;
            break;
          case 8:
            cov_syhivb711().b[10][1]++;
          case 9:
            cov_syhivb711().s[60]++;
            onAddressSelect(address);
            _context2.n = 11;
            break;
          case 10:
            _context2.p = 10;
            _t3 = _context2.v;
            cov_syhivb711().s[61]++;
            onError === null || onError === void 0 || onError(_t3);
          case 11:
            _context2.p = 11;
            cov_syhivb711().s[62]++;
            setIsLoading(false);
            return _context2.f(11);
          case 12:
            return _context2.a(2);
        }
      }, _callee2, null, [[4, 6], [1, 10, 11, 12]]);
    }));
    return function handlePredictionSelect(_x2) {
      return _ref14.apply(this, arguments);
    };
  }();
  cov_syhivb711().s[63]++;
  var renderItem = function renderItem(prediction) {
    cov_syhivb711().f[12]++;
    // Map size to typography for consistent styling
    var typographyMap = (cov_syhivb711().s[64]++, {
      xsmall: '$bodyMedium',
      small: '$bodyMedium',
      medium: '$bodyLarge',
      large: '$bodyXlarge'
    });
    var typography = (cov_syhivb711().s[65]++, size ? (cov_syhivb711().b[12][0]++, typographyMap[size]) : (cov_syhivb711().b[12][1]++, '$bodyXlarge'));
    cov_syhivb711().s[66]++;
    return /*#__PURE__*/React.createElement(Text, {
      typography: typography,
      tag: "span",
      textAlign: "left",
      $smallerThanMD: {
        typography: '$bodyMedium'
      },
      px: 10,
      py: 2
    }, prediction.description);
  };
  var displayIcon = (cov_syhivb711().s[67]++, (_ref15 = (cov_syhivb711().b[13][0]++, icon)) !== null && _ref15 !== void 0 ? _ref15 : (cov_syhivb711().b[13][1]++, isLoading ? (cov_syhivb711().b[14][0]++, /*#__PURE__*/React.createElement(Box, {
    position: "relative",
    px: 5
  }, /*#__PURE__*/React.createElement(ButtonLoadingAnimation, {
    variant: "secondary",
    size: "xsmall"
  }))) : (cov_syhivb711().b[14][1]++, /*#__PURE__*/React.createElement(Icons.Search, null))));
  var useSuffix = (cov_syhivb711().s[68]++, displayIcon);
  cov_syhivb711().s[69]++;
  if (actionButton) {
    cov_syhivb711().b[15][0]++;
    cov_syhivb711().s[70]++;
    var onPress = function onPress() {
      cov_syhivb711().f[13]++;
      cov_syhivb711().s[71]++;
      if ((cov_syhivb711().b[17][0]++, predictions.length) && (cov_syhivb711().b[17][1]++, predictions[0])) {
        cov_syhivb711().b[16][0]++;
        cov_syhivb711().s[72]++;
        handlePredictionSelect(predictions[0]);
      } else {
        cov_syhivb711().b[16][1]++;
        cov_syhivb711().s[73]++;
        if ((cov_syhivb711().b[19][0]++, usedPrediction) && (cov_syhivb711().b[19][1]++, searchTerm === usedPrediction.description)) {
          cov_syhivb711().b[18][0]++;
          cov_syhivb711().s[74]++;
          handlePredictionSelect(usedPrediction);
        } else {
          cov_syhivb711().b[18][1]++;
        }
      }
    };
    var renderedButton = (cov_syhivb711().s[75]++, actionButton(onPress, isLoading));
    cov_syhivb711().s[76]++;
    useSuffix = renderedButton;
  } else {
    cov_syhivb711().b[15][1]++;
  }
  cov_syhivb711().s[77]++;
  return /*#__PURE__*/React.createElement(AutocompleteInput, {
    id: id,
    label: label,
    hideLabel: hideLabel,
    placeholder: placeholder,
    disabled: disabled,
    items: predictions,
    searchTerm: searchTerm,
    onSearchChange: handleInputChange,
    onItemSelect: handlePredictionSelect,
    renderItem: renderItem,
    suffix: useSuffix,
    customAction: customAction,
    listBoxId: listBoxId,
    onEscape: function onEscape() {
      cov_syhivb711().f[14]++;
      cov_syhivb711().s[78]++;
      return clearPredictions();
    },
    onFocus: onFocus,
    onBlur: onBlur,
    listBoxAriaLabel: listBoxAriaLabel,
    size: size,
    supportText: supportText,
    errorText: errorText,
    invalid: invalid,
    required: required,
    inputRef: inputRef
  });
};
export default AddressInput;
//# sourceMappingURL=AddressInput.mjs.map